import { templateIsQuerx } from "../helpers/constants";

// Gets called everytime, when template key is found in raw JSON.
export function handleTemplateVal(device_id, template_val, store, devicesActionCreators, uiActionCreators) {
    console.log("handleTemplateVal", template_val);
    let { dispatch, getState } = store;
    //let { requestSetTemplateId, requestActivateTemplate } = devicesActionCreators;
    let { setDetectedQuerx } = uiActionCreators;
  

    // TEMP: Show prompt only for Querx devices. Do nothing for others
    let isQuerxTemplate = templateIsQuerx(template_val)
    if (!isQuerxTemplate) {
        console.log("Template does not identify a querx. Surpressing Autoconfig.", isQuerxTemplate);
        return;
    }

    // Check if a template is already applied to this device (via device api field "template val" {undefined|false, template_val}).
    //    Get appropriate slice of state

    let state = getState();
    if (!(state && state.devices && state.devices.length > 0 && state.devices.some(device => {return device.uid === device_id}))) {
      console.error("Device not found. Surpressing Autoconfig.")
      return;
    };
    //    also: Only offer auto config if detectedQuerx is not set 
    if (!(state && state.ui && state.ui.hasOwnProperty("detectedQuerx") && !state.ui.detectedQuerx)) {
        console.log("Detected Querx Dialog already open! Surpressing Autoconfig.");
        return;
    }
    //and if template_id is not on blacklist.
    if (!(state && state.uiConfig && state.uiConfig.hasOwnProperty("templateBlacklist"))) {
        return;
    }else{
        for (const blacklistEntry of state.uiConfig.templateBlacklist) {
            let { device_uid: bl_device_uid, template_val: bl_template_val } = blacklistEntry;
            if (device_id === bl_device_uid && template_val ===  bl_template_val) {
                console.log("Template/Device combination on blacklist. Surpressing Autoconfig.");
                return;
            }
        }
    }

    // and if device config modal is open

  
    let potentialDevices = state.devices.filter(device => {return device.uid === device_id}); // arr
    let deviceTemplateId; 
    if (potentialDevices && potentialDevices.length>0 && potentialDevices[0] && potentialDevices[0].hasOwnProperty("template_id")) {
      deviceTemplateId = potentialDevices[0]["template_id"];
    }else{
      console.error("Device not found / No template_id key found.");
      return;
    }
  
    // Now deviceid is either undefined/false or contains a template_id

    //let qname = isQuerxTemplate; // this cant be false here, so it contains the querx type name
    // If not, show a modal "Device XY recognized. Do you want to config it autom.?"
    //let shouldActivateTemplate;
    if(deviceTemplateId !== template_val){
      //shouldActivateTemplate = window.confirm("Querx recognized! Do you want to automatically configure the device?");
      dispatch(setDetectedQuerx(isQuerxTemplate, template_val, device_id));
    }else{
      console.log("Template Id recognized, but already set for this device.")
      return;
    }

  
  
  
    console.log("TEMPLATE RECOGNIZED!", template_val);
  }

